import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-funfacts-feedback',
  templateUrl: './funfacts-feedback.component.html',
  styleUrls: ['./funfacts-feedback.component.scss']
})
export class FunfactsFeedbackComponent implements OnInit, OnDestroy {

    private resizeTimer: any;

    constructor() { }

    ngOnInit(): void {
    }

    @HostListener('window:resize')
    onWindowResize(): void {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
            this.feedbackSlides = { ...this.feedbackSlides };
        }, 250);
    }

    ngOnDestroy(): void {
        clearTimeout(this.resizeTimer);
    }

    bgImage = [
        {
            img: 'assets/img/white-bg.jpg'
        }
    ]

    feedbackSlides: OwlOptions = {
        loop: true,
        nav: false,
        dots: true,
        autoplayHoverPause: true,
        autoplay: true,
        animateOut: 'fadeOut',
        autoHeight: true,
        items: 1,
        navText: [
            "<i class='bx bx-chevron-left'></i>",
            "<i class='bx bx-chevron-right'></i>"
        ]
    }

}